import * as React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import LayoutTemplate from '../../components/layout/IndexLayout'
import sizeMe from 'react-sizeme';
import * as Scroll from 'react-scroll';
import { animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import { ApplicationState, ConnectedReduxProps } from '../../store'
import { Project } from '../../store/projects/types'
import { fetchRequest, bulkUpdate, reset } from '../../store/projects/actions'
import { Dispatch } from 'redux'
// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
  loading: boolean
  data: Project[]
  errors?: string
}
interface InterfaceProps {
  users?: any
}
interface PassedProps {
  background: String
  colSpan: number
}
// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest
  reset: typeof reset
  bulkUpdate: typeof bulkUpdate
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps & InterfaceProps & PassedProps

class ProjectsIndexPage extends React.Component<AllProps> {
  constructor(props: any) {
    super(props)

    this.state = {
      loading: false,
      projects: [],
      size: sizeMe,
      data: []
    }
  }
  public componentDidMount() {
    const { data } = this.props
    scrollSpy.update();

    if (data.length === 0)
    {
      this.props.fetchRequest(1)
      // this.props.bulkUpdate();

    } else {
      if (data[0].type==2) {
        this.props.reset()
        this.props.fetchRequest(1)
      }
    }
  }

  public render() {
    const { loading, size, data, fetchRequest } = this.props;
    // console.log(this.props.data);
    return (<LayoutTemplate loading={loading} title={'PROJECTS'} subtitle={'ARTWORKS, MATERIAL AND CONTEXT'} logo={'none'}
      size={size} data={data} category={'projects'} fetchRequest={fetchRequest} />)
  }
}
// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = ({ projects }: ApplicationState) => ({
  loading: projects.loading,
  errors: projects.errors,
  data: projects.data
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = (dispatch: Dispatch) => ({
  //fetchRequest: (projectType:number) => dispatch(fetchRequest(projectType)),
  fetchRequest: (doc?:any) => dispatch(fetchRequest(doc)),
  bulkUpdate: (projectType:number) => dispatch(bulkUpdate(projectType)),
  reset: () => dispatch(reset())
})

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(sizeMe()(ProjectsIndexPage))
